import React, { useState, useEffect } from "react";
import { getIdData, addData, updateData } from "../../../lib/awardlist";
import { useNavigate, useParams } from "react-router-dom";
import { ClassForLessonSelect, RankingSelect } from '../../ui/myselect'
import { RecognitionLevelSelect } from '../../ui/myselect'
import { useAuth } from '../../../usercontext'
import STopMenu from '../../../components/student/topmenu/topmenu'
import S911TopMenu from '../../student911/topmenu/topmenu'
import S12TopMenu from '../../student12/topmenu/topmenu'

export default function StudentActivityEdit() {
	const [gradelevel, setGradelevel] = useState()
	const [recoglevel, setRecoglevel] = useState()
	const [sortOrder, setSortOrder] = useState(0)
	const [description, setDescription] = useState()
	const [ranking, setRanking] = useState()
	const [data, setData] = useState([])
	const { profile } = useAuth()

	const navigate = useNavigate()
	let { slug, id } = useParams()
	const studentId = profile.id

	async function GetData() {
		const organizationData = await getIdData(id)
		setData(organizationData)
		setDescription(organizationData[0].description)
		setGradelevel(organizationData[0].gradelevel)
		setRecoglevel(organizationData[0].recoglevel)
		setSortOrder(organizationData[0].sortorder)
		setRanking(organizationData[0].ranking)
	}

	const handleSubmit = async (e) => {
		e.preventDefault()

		if (slug === 'Add') {
			await addData({
				studentId: profile.id,
				gradelevel: gradelevel,
				recoglevel: recoglevel,
				description: description,
				sortorder: sortOrder,
				ranking: ranking
			})
		} else {
			await updateData({
				id: id,
				gradelevel: gradelevel,
				recoglevel: recoglevel,
				description: description,
				sortorder: sortOrder,
				ranking: ranking
			})
		}
		navigate(-1)
	}

	useEffect(() => {
		if (slug === 'Update') {
			GetData()
		}
	}, [slug])
	const isStudent911 = profile?.role === 'Student911'
	const isStudent12 = profile?.role === 'Student12'
	const isStudent = profile?.role === 'Student'
	const grade = profile?.role.toLowerCase()
	return (
		<>
			{isStudent && <STopMenu slug={studentId} activeMenu="AwardsEdit" />}
			{isStudent911 && <S911TopMenu slug={studentId} activeMenu="AwardsEdit" />}
			{isStudent12 && <S12TopMenu slug={studentId} activeMenu="AwardsEdit" />}
			<div className="col-12">
				<div className="settings-widget profile-details">
					<div className="settings-menu p-0">
						<div className="profile-heading">
							<h3>{slug === 'Add' ? 'Add Award' : 'Update Award'}</h3>
						</div>
						<div className="checkout-form personal-address add-course-info ">
							<form role="form" onSubmit={handleSubmit}>
								<div className="row mx-auto">
									<div className="col-9">
										<div className="form-group">
											<label className="form-control-label">Order</label>
											<input type="number" value={sortOrder} onChange={(e) => setSortOrder(e.target.value)} className="form-control" required />
										</div>
									</div>
									<div className="col-9">
										<div className="form-group">
											<label className="form-control-label">Recognition Level</label>
											<RecognitionLevelSelect value={recoglevel} setValue={setRecoglevel} />
										</div>
									</div>
									<div className="col-9">
										<div className="form-group">
											<label className="form-control-label">Grade Level</label>
											<ClassForLessonSelect value={gradelevel} name={'Grade Level'} setValue={setGradelevel} />
										</div>
									</div>
									<div className="col-9">
										<div className="form-group">
											<label className="form-control-label">Ranking</label>
											<RankingSelect value={ranking} setValue={setRanking} />
										</div>
									</div>
									<div className="col-9">
										<div className="form-group">
											<label className="form-control-label">Award</label>
											<textarea
												rows="4"
												value={description}
												onChange={(e) => setDescription(e.target.value)}
												className="form-control"
												placeholder="Award Description"
											></textarea>
										</div>
									</div>
									<div className="update-profile d-flex justify-content-between">
										<button type="submit" className="btn btn-primary">
											{slug === 'Add' ? 'Add Award' : 'Update Award'}
										</button>
										<button onClick={() => navigate(`/${grade}/student-awards`)} className="btn btn-black btn-sm">
											Cancel
										</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
